/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Manage_PermissionsInputs */



/**
* | output |
* | --- |
* | "Manage Permissions" |
*
* @param {Knp_Guide_Manage_PermissionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_manage_permissions = /** @type {((inputs?: Knp_Guide_Manage_PermissionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Manage_PermissionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer les autorisations")
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci permessi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление правами доступа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrar permisos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理权限")
	if (locale === "ja") return /** @type {LocalizedString} */ ("権限の管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमतियाँ प्रबंधित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciar permissões")
	return /** @type {LocalizedString} */ ("Manage Permissions")
});